import React from 'react'
import { Swiper } from 'modules'
import { ArrowRight } from 'core/icons'
import tulkojumi from 'utils/tulkojumi'
import { Download as DownloadIcon } from 'core/icons'
import { getImageUrlFromThumb } from 'utils';
import {
  StyledGalerija,
  StyledFigure,
  ButtonNext,
  ButtonPrev,
  ImageIndex,
  DownloadLink,
} from './styled'

class Galerija extends React.PureComponent {
  state = {
    sliderStyle: 0
  }

  render() {
    const { images, teksti, insideContent } = this.props

    const renderImage = (image, i) => {
      const url = image.thumb && Array.isArray(image.thumb) && image.thumb.length > 0 && image.thumb[0].url
      return (
        <StyledFigure>
          <img src={url} alt={image.alt} />
          <figcaption>
            <span>
              {`${i + 1} ${tulkojumi(teksti, 'no')} ${images.length}`}
            </span>
            <span>
              {image.caption}
            </span>
            <span style={{ marginLeft: 'auto' }}>
              <DownloadLink href={getImageUrlFromThumb(url)} target='_blank' title={tulkojumi(teksti, 'apskatit_attelu_originalizmera')}>
                <DownloadIcon size='large' />
              </DownloadLink>
            </span>
          </figcaption>
        </StyledFigure>
      )
    }
    const slides = images && images.map(renderImage)

    const navigationProps = {
      type: 'text',
      icon: ArrowRight,
      onClick: () => { }
    }

    return (
      <StyledGalerija insideContent={insideContent}>
        <Swiper
          marginStyle={this.state.sliderStyle}
          swiperInit={() => {
            const activeSlide = document.querySelector('.swiper-slide-active')
            const activeImage = activeSlide.querySelector('img')
            this.setState(prevState => ({
              sliderStyle: -(activeSlide.offsetHeight - activeImage.offsetHeight) / 2
            }))
          }}
          slides={slides}
          spaceBetween
          overlayNav
          nextButton={
            <ButtonNext
              {...navigationProps} />
          }
          prevButton={
            <ButtonPrev
              {...navigationProps} />
          }
          teksti={teksti} />
      </StyledGalerija>
    )
  }
}

export default Galerija



// WEBPACK FOOTER //
// ./src/pages/Raksts/components/Galerija/Galerija.jsx